/**
 * UI copy and display helpers for Bug RCA modal.
 */

export const BUG_RCA_COPY = {
  modalTitle: 'Root Cause Analysis',
  historicalScopeNote:
    'RCA is based on the product knowledge and test coverage available at the time of bug creation.',
  cachedResultLabel: 'Cached result',
  analyzedAtPrefix: 'Analyzed',
  refreshAnalysis: 'Re-analyze',
  retryAnalysis: 'Retry',
  unavailableMessage: 'RCA result unavailable. Try re-analyzing to regenerate the analysis.',
  gapsDetectedTitle: 'Gaps Detected',
  testGapSectionTitle: 'Historical Test Coverage Gap',
  gapTypePrefix: 'Gap Type:',
  confidencePrefix: 'Confidence:',
  similarTestsHeading: 'Similar Test Cases:',
};

export const BUG_RCA_GAP_TYPE_LABELS = {
  missing_test: 'Missing historical test coverage',
  insufficient_coverage: 'Insufficient historical test coverage',
  none: 'Historical coverage present',
  unknown: 'Unknown historical coverage gap',
};

export function hasValidRcaPayload(data) {
  if (!data || typeof data !== 'object') return false;
  if (data.error) return false;

  const hasAnalysis =
    data.test_gap_analysis != null ||
    data.requirement_mapping != null ||
    data.impact_analysis_miss != null ||
    typeof data.has_gaps === 'boolean';

  return Boolean(data.issue_key) && hasAnalysis;
}

export function resolveGapTypeLabel(testGapAnalysis) {
  if (!testGapAnalysis) return '—';
  if (testGapAnalysis.gap_type_label) return testGapAnalysis.gap_type_label;
  const gapType = testGapAnalysis.gap_type;
  if (gapType && BUG_RCA_GAP_TYPE_LABELS[gapType]) return BUG_RCA_GAP_TYPE_LABELS[gapType];
  if (!gapType) return '—';
  return String(gapType).replace(/_/g, ' ');
}

export function resolveHistoricalScopeNote(rcaData) {
  return rcaData?.historical_scope_note || BUG_RCA_COPY.historicalScopeNote;
}

export function formatRcaAnalyzedCaption(rcaData) {
  if (!hasValidRcaPayload(rcaData)) return null;
  const analyzedAt = rcaData.analyzed_at || rcaData.computed_at;
  if (!analyzedAt) return null;
  const dateText = new Date(analyzedAt).toLocaleString();
  if (rcaData.cached) {
    return `${BUG_RCA_COPY.cachedResultLabel} · ${BUG_RCA_COPY.analyzedAtPrefix} ${dateText}`;
  }
  return `${BUG_RCA_COPY.analyzedAtPrefix} ${dateText}`;
}
